export function buildPathDerivedResources<T>(
  entries: [string, T][],
  featuresSegment = 'features',
): Record<string, T> {
  return entries.reduce<Record<string, T>>((result, [modulePath, resource]) => {
    const normalizedPath = modulePath.replaceAll('\\', '/')
    const segments = normalizedPath.split('/')
    const featuresIndex = segments.lastIndexOf(featuresSegment)

    let key: string

    if (featuresIndex === -1) {
      const basename = segments.at(-1)

      if (!basename?.endsWith('.no.json')) {
        throw new Error(`Unable to determine translation key for module: ${modulePath}`)
      }

      key = basename.slice(0, -'.no.json'.length).toLowerCase()
    } else {
      const dirSegments = segments.slice(featuresIndex + 1, -1)

      if (dirSegments.length === 0) {
        throw new Error(
          `No directory segments found between '${featuresSegment}' and filename in: ${modulePath}`,
        )
      }

      key = dirSegments.join('-').toLowerCase()
    }

    if (result[key]) {
      throw new Error(`Discovered multiple .no.json files for path-derived key '${key}'`)
    }

    result[key] = resource
    return result
  }, {})
}
